class VirtualCart extends HTMLElement {
  constructor() {
    super();
    this.data = {
      lines: [],
      localization: {
        country: {
          isoCode: this.hasAttribute('country') ? this.getAttribute('country') : null,
        }
      },
      currency: {
        format: this.hasAttribute('money-format') ? this.getAttribute('money-format') : "€{{amount_with_comma_separator}}",
        currencyCode: this.hasAttribute('currency') ? this.getAttribute('currency') : null
      }
    }
  }
  formatMoney(cents, format) {
    const formatWithDelimiters = function (number, precision, thousands, decimal) {
      precision = typeof precision != "undefined" ? precision : 2;
      thousands = typeof thousands != "undefined" ? thousands : ".";
      decimal = typeof decimal != "undefined" ? decimal : ",";

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split(".");
      let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      let cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }
    let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    let money_format = format;
    let value = null;
    switch (money_format.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
    }

    return money_format.replace(placeholderRegex, value);
  }
  multiATC(){
    let payload = {
      'items': []
    };
    payload.items = this.data.lines.map(({ variantId, quantity }) => ({'id': variantId, 'quantity': quantity, 'properties': {'_lp_exclusive': 'true'}}));
    const cartAddItem = {
      url: `${Shopify.routes.root}cart/add.js`,
      options: {
        body: JSON.stringify(payload),
        method: "POST",
        headers: {
          "Content-Type": "application/json", 
          "Accept": "application/json"
        }
      },
      callback: (response) => {
        console.log('adding delay -> ', payload.items.length * 50);
        setTimeout(() => {
          this.classList.remove('loading');
          window.location.href = `${Shopify.routes.root}checkout`;
        }, payload.items.length * 100);
      },
      error: (error) => {
        this.classList.remove('loading');
        console.error("Cart add failed!");
      }
    }
    Shopify.cartQueue.enqueue(cartAddItem);
  }
  singleATC(){
    const that = this;
    const line_count = this.data.lines.length;
    const singleATCs = this.data.lines.map(({ variantId, quantity }, index) => (
      {
        url: `${Shopify.routes.root}cart/add.js`,
        options: {
          body: JSON.stringify({'items': [{'id': variantId, 'quantity': quantity, 'properties': {'_lp_exclusive': 'true'}}]}),
          method: "POST",
          headers: {
            "Content-Type": "application/json", 
            "Accept": "application/json"
          }
        },
        callback: (response) => {
          if((index+1) >= line_count){
            that.classList.remove('loading');
            console.log('last item added!');
            window.location.href = `${Shopify.routes.root}checkout`;
          }
        },
        error: (error) => {
          this.classList.remove('loading');
          console.error("Cart add failed!");
        }
      }
    ));
    singleATCs.map((singleATC) => (Shopify.cartQueue.enqueue(singleATC)));
  }
  submit() {
    this.classList.add('loading');
    const clearCartItem = {
      url: `${Shopify.routes.root}cart/clear.js`,
      options: {
        method: "POST"
      },
      callback: (response) => {
        console.log('cart-cleared');
      },
      error: (error) => {
        console.error("Cart clear failed!");
      }
    }
    Shopify.cartQueue.enqueue(clearCartItem);
    if(this.addFunction === 'multi') {
      this.multiATC();
    } else {
      this.singleATC();
    }
  }
  updateSection(originalTotal, discountedTotal, cartCount, format) {
    const savedAmount = Math.max(originalTotal - discountedTotal, 0);
    const savedPercent = discountedTotal > 0 ? Math.round((savedAmount * 100) / originalTotal) : 0;
    const originalTotalFormatted = this.formatMoney(originalTotal, format);
    const discountedTotalFormatted = this.formatMoney(discountedTotal, format);
    const savedAmountFormatted = this.formatMoney(savedAmount, format);
    const savedPercentFormatted = savedPercent+'%';

    if(cartCount < 1) {
      // no items in virtual cart -> disable buy buttons
      this.setAttribute('disable-checkout', '');
      this.querySelectorAll('[checkout-button]').forEach(button => {
        button.setAttribute('disabled', '');
      });
      this.querySelectorAll('[data-only-discount]').forEach(container => {
        container.classList.add('hidden');
      });
    } else {
      // at least on item in virtual cart -> set estimated cart total
      this.removeAttribute('disable-checkout');
      this.querySelectorAll('[checkout-button]').forEach(button => {
        button.removeAttribute('disabled');
      });
      this.querySelectorAll('[data-original-total]').forEach(container => {
        if(originalTotal > discountedTotal) {
          container.innerHTML = originalTotalFormatted;
          container.classList.remove('hidden');
        } else {
          container.classList.add('hidden');
        }
      });
      this.querySelectorAll('[data-discounted-total]').forEach(container => {
        container.innerHTML = discountedTotalFormatted;
      });
      this.querySelectorAll('[data-only-discount]').forEach(container => {
        if(originalTotal > discountedTotal) {
          container.classList.remove('hidden');
        } else {
          container.classList.add('hidden');
        }
      });
      this.querySelectorAll('[data-item-count]').forEach(container => {
        container.innerHTML = cartCount;
      });
      this.querySelectorAll('[data-saved-amount]').forEach(container => {
        container.innerHTML = savedAmountFormatted;
      });
      this.querySelectorAll('[data-saved-percent]').forEach(container => {
        container.innerHTML = savedPercentFormatted;
      });
    }
  }
  connectedCallback() {
    this.addFunction = this.getAttribute('add-function') ?? 'multi';
    this.basePrice = this.getAttribute('base_price') ?? 'price';
    const clearCartItem = {
      url: `${Shopify.routes.root}cart/clear.js`,
      options: {
        method: "POST"
      },
      callback: (response) => {
        console.log('cart-cleared');
      },
      error: (error) => {
        console.error("Cart clear failed!");
      }
    }
    Shopify.cartQueue.enqueue(clearCartItem);
    this.addEventListener('virtual-cart:change', event => {
      if(event?.detail?.cart){
        let originalTotal = null;
        if(this.basePrice === "compare_at_price") {
          originalTotal = window.Hy.ZoevaDiscounts.landingPageExclusiveDiscount.calculateCompareAtTotal(event.detail.cart) * 100;
        } else {
          originalTotal = window.Hy.ZoevaDiscounts.landingPageExclusiveDiscount.calculateTotal(event.detail.cart) * 100;
        }
        const discountedTotal = window.Hy.ZoevaDiscounts.landingPageExclusiveDiscount.calculateDiscountedTotal(event.detail.cart) * 100;
        const moneyFormat = event.detail.cart.currency.format;
        const cartCount = event.detail.cart.lines.reduce((accumulator, line) => accumulator + line.quantity, 0);
        this.updateSection(originalTotal, discountedTotal, cartCount, moneyFormat)
      }
    }); 
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        window.location.reload() 
      }
    });
    this.querySelectorAll('[checkout-button]').forEach(button => {
      button.addEventListener('click', event => {
        if(!button.hasAttribute('disabled')){
          this.submit();
        }
      });
    });
  }
}
class VariantItem extends HTMLElement {
  constructor() {
    super();
  }
  addItem() {
    const currentItem = this.data;
    if(this.virtualCart?.data?.lines) {
      const existingLine = this.virtualCart.data?.lines?.find(line => line.variantId === currentItem.variantId);
      if(existingLine) {
        existingLine.quantity += currentItem.quantity;
      } else {
        this.virtualCart.data?.lines?.push(currentItem);
      }
    }
    this.dispatchEvent(new CustomEvent('virtual-cart:change', {
      bubbles: true, 
      detail: {
        item: currentItem,
        cart: this.virtualCart.data
      }
    }));
  }
  removeItem() {
    const currentItem = this.data;
    if(this.virtualCart?.data?.lines) {
      const existingLine = this.virtualCart.data?.lines?.find(line => line.variantId === currentItem.variantId);
      if(existingLine && existingLine.quantity > currentItem.quantity) {
        existingLine.quantity -= currentItem.quantity;
      } else {
        this.virtualCart.data.lines = this.virtualCart.data?.lines?.filter(line => line.variantId !== currentItem.variantId);
      }
    }
    this.dispatchEvent(new CustomEvent('virtual-cart:change', {
      bubbles: true, 
      detail: {
        item: currentItem,
        cart: this.virtualCart.data
      }
    }));
  }
}
class BundleItem extends VariantItem {
  constructor() {
    super();
  }
  connectedCallback() {
    this.virtualCart = this.closest('virtual-cart');
    this.data = {
      title: this.hasAttribute('product-title') ? this.getAttribute('product-title') : '',
      type: "default",
      productId: this.hasAttribute('product-id') ? Number(this.getAttribute('product-id')) : null,
      variantId: this.hasAttribute('variant-id') ? Number(this.getAttribute('variant-id')) : null,
      price: this.hasAttribute('variant-price') ? Number(this.getAttribute('variant-price')) : null,
      compareAtPrice: this.hasAttribute('variant-compare-at-price') ? Number(this.getAttribute('variant-compare-at-price')) : null,
      quantity: 1
    }
    this.input = this.querySelector('input.bundle-item-input');
    if(this.input) {
      if(this.input.checked) {
        super.addItem();
      }
      this.input.addEventListener('input', event => {
        if(this.input.checked) {
          super.addItem();
        } else {
          super.removeItem();
        }
      });
    }
  }
}
class UpsellItem extends VariantItem {
  constructor() {
    super();
  }
  setFixedTop() {
    const header = document.querySelector('.header-inner-wrapper');
    const stickyItems = document.querySelectorAll('upsell-item.is-sticky');
    if (!!header) {
      let previousItemsHeight = header.clientHeight;
      let zIndex = 10 + stickyItems.length;
      stickyItems.forEach((item) => {
        if (item.getBoundingClientRect().top < this.getBoundingClientRect().top) {
          previousItemsHeight += item.clientHeight;
          zIndex--;
        }
      })
      this.style.setProperty('--previous-elements', previousItemsHeight - 0.5 + 'px');
      this.style.zIndex = zIndex;
    }
  }
  connectedCallback() {
    this.virtualCart = this.closest('virtual-cart');
    this.data = {
      title: this.hasAttribute('product-title') ? this.getAttribute('product-title') : '',
      type: "upsell",
      productId: this.hasAttribute('product-id') ? Number(this.getAttribute('product-id')) : null,
      variantId: this.hasAttribute('variant-id') ? Number(this.getAttribute('variant-id')) : null,
      price: this.hasAttribute('variant-price') ? Number(this.getAttribute('variant-price')) : null,
      compareAtPrice: this.hasAttribute('variant-compare-at-price') ? Number(this.getAttribute('variant-compare-at-price')) : null,
      quantity: 1
    }
    this.setFixedTop();
    this.input = this.querySelector('input.upsell-item-input');
    if(this.input) {
      if(this.input.checked) {
        super.addItem();
      }
      this.input.addEventListener('input', event => {
        if(this.input.checked) {
          super.addItem();
        } else {
          super.removeItem();
        }
      });
    }
    this.triggerQuantity = this.hasAttribute('trigger-quantity') ? Number(this.getAttribute('trigger-quantity')) : 0;
    this.autoSelectQuantity = this.hasAttribute('auto-select') ? Number(this.getAttribute('auto-select')) : null;
    if(this.autoSelectQuantity || this.triggerQuantity > 0){
      this.virtualCart.addEventListener('virtual-cart:change', event => {
        if(event.detail.item.type === 'default') {
          const cartCount = event.detail.cart.lines.filter(line => line.type === "default").reduce((accumulator, line) => accumulator + line.quantity, 0);
          if(cartCount >= this.triggerQuantity) {
            this.input.removeAttribute('disabled')
          } else {
            if(this.input.checked) {
              this.input.checked = false;
              super.removeItem();
            }
            this.input.setAttribute('disabled', '')
          }
          if(this.autoSelectQuantity && cartCount >= this.autoSelectQuantity && !this.input.checked) {
            this.input.checked = true;
            super.addItem();
          }
        }
      });
    }
  }
}
customElements.define("virtual-cart", VirtualCart);
customElements.define("upsell-item", UpsellItem);
customElements.define("bundle-item", BundleItem);